<template>
  <section class="hero">
    <div class="row">
      <div class="col-md-offset-1 col-md-5 col-xs-9 landing">
        <FadeRight appear :duration="500" :delay="1300">
          <h2 class="heroGreet">&mdash; Welcome.</h2>
        </FadeRight>
        <FadeRight appear :duration="500" :delay="1300">
          <div class="heroText">
            <h3>
              I'm Robbey, a multi-disciplinary designer and creative
              at&nbsp;&nbsp;<a
                class="animateLink hoverLink"
                href="https://www.snapchat.com/"
                >Snapchat</a
              >&nbsp;&nbsp;in New York City.
            </h3>
            <h3>
              I love crafting interfaces and products that are thoughtful and accessible for all.
            </h3>
          </div>
        </FadeRight>
        <FadeRight appear :duration="500" :delay="1300">
          <div class="row scroll">
            <router-link to="/#Projects" @click.native="scrollFix('#Projects')">
              <div class="arrow bounce">
                <i class="fa fa-arrow-down"></i>
              </div>
            </router-link>
          </div>
        </FadeRight>
      </div>
      <div class="row start-xs heroLogo">
        <LandingLogo
          class="col-xs col-sm-5 col-md-3"
          :options="logoLottie"
          v-on:animCreated="handleAnimation"
        />
        <div class="col-xs-2 show-xs-only"></div>
      </div>
    </div>
  </section>
</template>

<script>
import LandingLogo from "@/transitions/LandingLogo.vue";
import * as animationData from "../assets/WhiteLogo_Long.json";
import FadeRight from "@/transitions/FadeRight.vue";
import { setTimeout } from "timers";

const TIMEOUT = 1;
export default {
  name: "HomeLanding",
  components: {
    LandingLogo,
    FadeRight
  },
  data() {
    return {
      logoLottie: {
        animationData: animationData.default,
        rendererSettings: {
          preserveAspectRatio: "xMinYMin"
        }
      },
      greeting: [
        "Welcome",
        "Howdy",
        "Nice to meet you",
        "G'day",
        "Hello",
        "Womptastic"
      ]
    };
  },
  mounted() {
    // From testing, without a brief timeout, it won't work.
    if (this.$route.hash) {
      setTimeout(() => this.scrollFix(this.$route.hash), TIMEOUT);
    }
  },
  methods: {
    scrollFix: function(hashtag) {
      this.navOpen = false;
      setTimeout(() => {
        if (location.href.includes("/Project")) {
          window.scrollTo({
            top: document.querySelector(hashtag).offsetTop,
            behavior: "auto"
          });
        } else {
          window.scrollTo({
            top: document.querySelector(hashtag).offsetTop,
            behavior: "smooth"
          });
        }
      }, TIMEOUT);
    },
    handleAnimation: function(anim) {
      this.anim = anim;
      let Vue = this;
      // CHANGE THIS FOR LOOPING
      anim.loop = true;
      if (this.$store.state.firstLoad) {
        setTimeout(function() {
          anim.playSegments([0, 360], true);
          Vue.$store.state.firstLoad = false;
        }, 400);
      } else {
        anim.playSegments([0, 360], true);
      }
    },
    stopAnimation: function() {
      this.anim.stop();
    },
    reverseAnimation: function(anim) {
      this.anim = anim;
      anim.playSegments([60, 90], true);
    }
  }
};
</script>

<style lang="scss" scoped>
.hero {
  min-height: 100vh;
  z-index: 2;
  margin-bottom: 1.75rem;
}
.heroLogo {
  position: relative;
  z-index: 1;

  padding-left: 0;
  & > div {
    height: 100%;
  }
  // max-height: 25vw;
  @include respond-to(xs) {
    // padding: inherit;
    max-height: 50vh;
    width: inherit;
    margin-top: -20vh;
    // top: 30.645vh;
    // bottom: 8.75rem;
  }
  @include respond-to(sm) {
    bottom: 10.355vh; //10.355
    margin-top: 0vh;
  }
  // padding:auto;
}
.landing {
  @include respond-to(xs) {
    top: 26.355vh;
  }
  @include respond-to(sm) {
    top: 42vh; //42
  }
  position: relative;
  z-index: 2;
}

.heroGreet {
  font-size: 3rem;
  margin-left: -6.8vw;
  color: $dark-grey;
  @include respond-to(sm) {
    font-size: 4rem;
    margin-left: -1.4vw;
  }
}

.heroText {
  h3 {
    font-family: $text-font-stack;
    color: $dark-grey;
    line-height: 2.75rem;
    font-size: 1.4rem;
    letter-spacing: 16;
    font-weight: 300;
  }
  margin-top: 10vh;
}
.hoverLink {
  color: $mid-grey;
  font-family: $display-font-stack;
  font-style: italic;
  font-size: 1.5rem;
  &:hover {
    text-decoration: none;
    color: $brand-blue;
  }
  &:visited {
    color: $mid-grey;
  }
}

.scroll {
  margin-top: 32px;
  margin-bottom: 40px;
  padding-left: 0px;
  // padding-top: 24px;
  position: relative;
}
.arrow {
  color: $dark-grey;
  position: absolute;
}
.bounce {
  animation: bounce 4s infinite;
}

a.router-link-exact-active,
a.router-link-active {
  text-decoration: none;
}

a:hover {
  color: $brand-blue;
  text-decoration: none;
}

@keyframes bounce {
  0%,
  50%,
  70%,
  80%,
  100% {
    transform: translateY(0);
  }
  60% {
    transform: translateY(-24px);
  }
  75% {
    transform: translateY(-12px);
  }
}
</style>
